import React from 'react';
import { Clock } from 'lucide-react';
export function HowItWorksSection() {
  const steps = [{
    step: 1,
    when: 'Hoy, al recibir la guía',
    what: 'Imprimes o abres el Template 1 en tu celular/Canva'
  }, {
    step: 2,
    when: 'Esta tarde a las 6PM',
    what: 'Cenas ligero con el Menú Tranquila'
  }, {
    step: 3,
    when: 'Esta noche a las 8PM',
    what: 'Preparas tu Té Abuela — ingredientes del Oxxo'
  }, {
    step: 4,
    when: '9:45PM',
    what: '4 minutos de Respiración NM'
  }, {
    step: 5,
    when: '10PM',
    what: 'Luz off. Tú duermes.'
  }, {
    step: 6,
    when: 'Si te despiertas a las 3AM',
    what: 'Abres el Template 3. Escribes 5 min. Regresas a dormir.'
  }];
  return <section className="py-20 px-4 md:px-8 bg-navy-900 text-cream-100" data-id="element-202">
      <div className="max-w-4xl mx-auto" data-id="element-203">
        <div className="text-center mb-16" data-id="element-204">
          <span className="text-4xl mb-4 block" data-id="element-205">📋</span>
          <h2 className="text-gold-500 font-bold tracking-widest uppercase text-sm mb-2" data-id="element-206">
            SECCIÓN 7 — CÓMO FUNCIONA
          </h2>
          <h3 className="text-3xl md:text-4xl font-serif font-bold mb-6" data-id="element-207">
            "En 5 Minutos Sabes Exactamente Qué Hacer"
          </h3>
        </div>

        <div className="relative" data-id="element-208">
          {/* Vertical Line */}
          <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-gold-500/30 hidden md:block" data-id="element-209"></div>

          <div className="space-y-8" data-id="element-210">
            {steps.map(item => <div key={item.step} className="relative flex flex-col md:flex-row gap-6 md:items-center bg-navy-800 p-6 rounded-xl border border-navy-700" data-id="element-211">
                <div className="flex-shrink-0 flex items-center justify-center w-16 h-16 rounded-full bg-gold-500 text-navy-900 font-bold text-2xl z-10 shadow-lg shadow-gold-500/20" data-id="element-212">
                  {item.step}
                </div>
                <div className="flex-grow" data-id="element-213">
                  <p className="text-gold-400 font-bold uppercase text-sm mb-1 flex items-center gap-2" data-id="element-214">
                    <Clock className="h-4 w-4" data-id="element-215" />
                    {item.when}
                  </p>
                  <p className="text-xl text-cream-100 font-serif" data-id="element-216">
                    {item.what}
                  </p>
                </div>
              </div>)}
          </div>
        </div>

        <div className="mt-12 text-center bg-navy-800 p-6 rounded-xl border border-gold-500/30" data-id="element-217">
          <p className="text-lg text-cream-200" data-id="element-218">
            Tiempo total por día:{' '}
            <span className="text-gold-500 font-bold" data-id="element-219">15–20 minutos</span>. No
            necesitas leer todo de un jalón. Empieza por el Template 1 esta
            noche.
          </p>
        </div>
      </div>
    </section>;
}